class SingleCasesSmmHero {
    constructor(root) {
        this.root = root;
        this.items = Array.from(this.root.querySelectorAll('[data-smm-case-item]'));
        this.button = this.root.querySelector('[data-smm-cases-load-more]');
        this.initialCount = this.getPositiveNumber(this.root.dataset.smmCasesInitial, 3);
        this.step = this.getPositiveNumber(this.root.dataset.smmCasesStep, 3);
        this.visibleCount = Math.min(this.initialCount, this.items.length);

        if (!this.button || this.items.length <= this.visibleCount) {
            this.showAllItems();
            this.hideButton();
            return;
        }

        this.render();
        this.root.classList.add('is-ready');
        this.bindEvents();
    }

    getPositiveNumber(value, fallback) {
        const number = Number.parseInt(value, 10);

        return Number.isInteger(number) && number > 0 ? number : fallback;
    }

    bindEvents() {
        this.button.addEventListener('click', () => {
            this.visibleCount = Math.min(this.visibleCount + this.step, this.items.length);
            this.render();
        });
    }

    render() {
        this.items.forEach((item, index) => {
            const isHidden = index >= this.visibleCount;

            item.classList.toggle('is-hidden', isHidden);
            item.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
        });

        if (this.visibleCount >= this.items.length) {
            this.button.setAttribute('aria-expanded', 'true');
            this.hideButton();
        }
    }

    showAllItems() {
        this.items.forEach((item) => {
            item.classList.remove('is-hidden');
            item.removeAttribute('aria-hidden');
        });
    }

    hideButton() {
        if (this.button) {
            this.button.hidden = true;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-smm-cases]').forEach((root) => {
        new SingleCasesSmmHero(root);
    });
});
